<script setup>
import { computed, onBeforeMount, onMounted, ref, nextTick, watch, onUnmounted,onUpdated } from "vue";
import { useI18n } from 'vue-i18n';
import CustomInput from '@/components/common/utils/CustomInput.vue';
import CustomSelect from '@/components/common/utils/CustomSelect.vue';
import { endOfMonth, endOfYear, startOfMonth, startOfYear, subMonths } from 'date-fns';
import LocalStorage from '@/controller/LocalStorage.js';
import VueMultiselect from 'vue-multiselect';
import "vue-multiselect/dist/vue-multiselect.css";
import { icon } from "@fortawesome/fontawesome-svg-core";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import { getClients } from "@/services/api/Administration.js";
import { useWorkfilesStore } from '@/stores/workfiles';

import { storeToRefs } from "pinia";

const workfilesStore = useWorkfilesStore();
const workfiles = storeToRefs(workfilesStore);
const { getMultiselectValue: multiselectRecovery} = storeToRefs(workfiles);


const { t } = useI18n();
const emit = defineEmits(["filterChanged", "searchChanged"]);
const props = defineProps({
    type: String,
    data: [Object, Array],//data: [Object, String] cambio el string per array
    src: String,
    name: String,
    filters: Object,
    position: String,
    items: Object,
});

const totalHeight = computed(() => {
    return (Array.isArray(props.items) ? props.items.length * 50 : 0) + 'px';
});


const isMobileView = ref(()=> window.innerWidth <= 576);
const isDesktopView = ref(()=> window.innerWidth > 576)
const updateView = () => {
  isMobileView.value = window.innerWidth <= 576;
  isDesktopView.value = window.innerWidth > 576;
};
onMounted(() => {
  window.addEventListener('resize', updateView);
});

onUnmounted(() => {
  window.removeEventListener('resize', updateView);
});

const dpArrowTopPosition = ref('10%');
if(props.position == 'right'){
    dpArrowTopPosition.value = '80%';
}
const userColor = ref(LocalStorage.getColor());
const multiSelectColor = ref('#e5e7eb');
function filterChanged(newVal) { 
    if (newVal){
        if (newVal.length !== 0) {
        multiSelectColor.value = userColor.value;
    
        }else {
            multiSelectColor.value = '#e5e7eb';
        }
    }
    else {
        newVal = "";
    }
    let field = props.src ?? props.name; //Per columnes que es mostra la info de una key i es filtra per un altre key. P.ex: Llistat vehicles > marca
    
    emit("filterChanged", field, newVal);
}

function searchChanged(newVal) {
    emit("searchChanged", newVal);
}

const inputBorderColor = ref('#CBD5E1');
const textInputColor = ref('#000000');
const filterValue = computed(() => {
    let name = props.name !== 'image' ? props.name : props.src //workaround brand/image column at vehicles
    if (props.filters[name] !== null) {
        if (props.filters[name] !== '' && props.filters[name] !== undefined) {
            inputBorderColor.value = userColor.value;
            textInputColor.value = userColor.value;
            if (props.type === 'multiselect') {
                multiSelectColor.value = userColor.value;
            }
        }
        else {
            inputBorderColor.value = '#CBD5E1';
            textInputColor.value = '#000000';
        }
        return ref(props.filters[name]);
    }
    else {
        inputBorderColor.value = '#CBD5E1';
        textInputColor.value = '#000000';
        return ref('')
    }
});

const showMagnifier = ref(true);
function clearInputText() {
    //workaround for brand/imgae column at vehicles
    showMagnifier.value = true;
    let filter = props.name
    if(props.name == 'image' && props.src == 'brand'){
        filter = props.src;
    }
    emit("filterChanged", filter, '');
}
//CustomInput
var timer = 0;
function handleKeyUp(event) {
    let field = props.src ?? props.name; //Per columnes que es mostra la info de una key i es filtra per un altre key. P.ex: Llistat vehicles > marca
    emit("filterChanged", field, event.target.value);
}
function debouncedHandleKeyUp(event) {
    clearTimeout(timer);
    timer = setTimeout(() => {
        handleKeyUp(event);
      }, 500);
}
const svg =
`
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true" class="dp__icon dp__clear_icon dp__input_icons"><path d="M23.057 7.057l-16 16c-0.52 0.52-0.52 1.365 0 1.885s1.365 0.52 1.885 0l16-16c0.52-0.52 0.52-1.365 0-1.885s-1.365-0.52-1.885 0z"></path><path d="M7.057 8.943l16 16c0.52 0.52 1.365 0.52 1.885 0s0.52-1.365 0-1.885l-16-16c-0.52-0.52-1.365-0.52-1.885 0s-0.52 1.365 0 1.885z"></path></svg>
`;
//CustomInput



//calendar filter
const date = ref();
const dateBorderColor = ref('#e5e7eb');
const presetDates = ref([
  { label: 'Hoy', value: [new Date(), new Date()] },
  { label: 'Este mes', value: [startOfMonth(new Date()), endOfMonth(new Date())] },
  {
    label: 'Último mes',
    value: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))],
  },
  { label: 'Este año', value: [startOfYear(new Date()), endOfYear(new Date())] },
]);
function handleDateChangeClosed(){
    if(!date.value || !date.value.length) return;
    let start = new Date(date.value[0]);
    start.setHours(0, 0, 0, 0);
    let startTimestamp = Math.floor(start.getTime() / 1000);
 
    let end = new Date(date.value[1]);
    end.setHours(23, 59, 0, 0);
    let endTimestamp = Math.floor(end.getTime() / 1000);
   
    dateBorderColor.value = userColor.value;
    emit("filterChanged", props.name, {startDate: startTimestamp, endDate: endTimestamp});
}
function handleDateClear(){
    dateBorderColor.value = '#CBD5E1';
    emit("filterChanged", props.name, {startDate: null, endDate: null});
}
function dateformat(date) {
    let startdate = date[0];
    let enddate = date[1];
    let startdateDay = startdate.getDate().toString().padStart(2, '0');
    let startdateMonth = (startdate.getMonth() + 1).toString().padStart(2, '0');
    let startdateYear = startdate.getFullYear().toString().slice(-2);
    let enddateDay = enddate.getDate().toString().padStart(2, '0');
    let enddateMonth = (enddate.getMonth() + 1).toString().padStart(2, '0');
    let enddateYear = enddate.getFullYear().toString().slice(-2);
    return `${startdateDay}/${startdateMonth}/${startdateYear} - ${enddateDay}/${enddateMonth}/${enddateYear}`;
}
const updateMonth = (event, updateMonthYear, year) => {
  updateMonthYear(+(event.target).value, year);
};
const updateYear = (event, updateMonthYear, month) => {
  updateMonthYear(month, +(event.target).value);
};
const addMonth = (event, updateMonthYear, month, year) => {
    if(month == 11){
        updateMonthYear(0, year+1);
    }else{
        updateMonthYear(month+1, year);
    }
};
const minusMonth = (event, updateMonthYear, month, year) => {
    if(month == 0){
        updateMonthYear(11, year-1);
    }else{
        updateMonthYear(month-1, year);
    }
};
//calendar filter

//VueMultiselect
const multiselectValue = ref();
const multiselect = ref(null);
const multiselectClient = ref(null);
const selectedStatus = ref([]);

//const selection = ref([]);

onBeforeMount(() => {
    let statusList = [];
    if(props.name == 'status' && filterValue.value.value){
        if(typeof filterValue.value.value == 'string'){
            statusList = [filterValue.value.value];
        }else if(typeof filterValue.value.value == 'object'){
            statusList = filterValue.value.value.map((element) => element);
        }
        const selection = [];
        if(props.data.length){
            props.data.forEach(element => {
                let exists = statusList.some(item => element.id == item);
                if(exists)selection.push(element);
            });
        }
        multiselectValue.value = selection.map(item => ({...item}));
    }
    // Pre-carga para filtros de rango de fechas (date y reparationDate) usando el valor guardado en la store
    else if(['date','reparationDate'].includes(props.name) && filterValue.value && filterValue.value.startDate){
        let start = new Date(filterValue.value.startDate * 1000);
        let end = new Date((filterValue.value.endDate * 1000)-3600000);
        start.setHours(0, 0, 0, 0);
        end.setHours(23, 59, 0, 0);
        start = start.toISOString();
        end = end.toISOString();
        date.value = [start, end];
    }
    else if(props.name == 'clientId' && filterValue.value.value){
        if(multiselectRecovery.value && multiselectRecovery.value.name){
            multiselectValue.value = multiselectRecovery.value;
            if (Array.isArray(props.data)) {
                props.data.unshift(multiselectRecovery.value);
            }
        }
    }
});





function handleInternal(date){
    if(date && date.length){
        date = date.map(element => {
            element.setHours(0, 0, 0, 0);
            return element;
        });
    }
}

function handleFocus(){
    showMagnifier.value = false;
}
function handleBlur(event){
    if(event.target.value == ''){
        showMagnifier.value = true;
    }
}


watch(multiselectValue, (newVal) => {
    workfilesStore.setMultiselectValue(newVal); // Save newVal in the store
    if (newVal == null || newVal.length === 0) {
        if (Array.isArray(props.data) && props.name == 'clientId') {
            props.data.length = 0; // Clear the array
        }
    }
       
});
const placeholder = ref(t('workfiles.fast_filters.all'));
const focusTimeout = ref(null);
function handleFocusMs(){
    clearTimeout(focusTimeout.value)
    placeholder.value = '';
}

function handleBlurMs(){
    placeholder.value = t('workfiles.fast_filters.all');
}
const placeholderDP = ref(t('field.date'));
// const placeholderDP = ref(t('appointment.slots.date_title'));
function handleFocusDP(){
    placeholderDP.value = '';
}

function handleCloseDP(){
    placeholderDP.value = t('field.date');
    // placeholderDP.value = t('appointment.slots.date_title');
}
const isFocused = ref(false);

function handleChevronClick(isOpen, toggle) {
    if (!isOpen) {
        toggle();
    }
}
</script>

<template>
    <div class="custom-filter">
        <div class="cell-filter d-flex" v-if="type == 'input'">
            <CustomInput
                :value="filterValue.value"
                :placeholder="isFocused ? '' : t('field.search')"
                type="text"
                :name="props.name !== 'image' ? props.name : props.src"
                @focus="isFocused = true"
                @blur="isFocused = false"
                @keyup="debouncedHandleKeyUp"
                style="line-height: 1.5rem !important; box-sizing: content-box;padding-right: 28px;"
                :filled="props.filters[props.name]?.length || props.filters[props.src]?.length"
                >
            </CustomInput>
            <!-- <span class="search-svg"><font-awesome-icon icon="fa-solid fa-magnifying-glass" v-if="showMagnifier"/></span> -->
            <span class="clearInputText" role="button" @click="clearInputText" v-html="svg" v-show="props.filters[props.name]?.length || props.filters[props.src]?.length"></span>
        </div>
        <div class="cell-filter" v-if="type == 'select'">
            <CustomSelect
                :value="filterValue.value"
                :name="props.name"
                :items="props.data"
                :template="'1'"
                :multiple="false"
                @update:modelValue="filterChanged" 
                >
            </CustomSelect>
        </div>
        <div class="cell-filter" :class="{ 'little-height': parseInt(totalHeight) < 200 && props.data.length }" v-if="type == 'multiselect' && props.name == 'clientId'">
            <VueMultiselect
                v-model="multiselectValue"
                class="multiselect"
                :placeholder="placeholder"
                label="name"
                track-by="name"
                :options="props.data"
                :multiple="false"
                :searchable="true"
                :selectLabel="'✓'"
                :deselectLabel="''"
                :selectedLabel="'✓'"
                :preserve-search="true"
                :closeOnSelect="true"
                @open="handleFocusMs"
                @close="handleBlurMs"
                @update:modelValue="filterChanged"
                @search-change="searchChanged"
                ref="multiselect">
                <template #selection="{ values, search, isOpen }">
                    <span class="multiselect-selection-length-text" v-if="multiselectValue && !isOpen"> {{ multiselectValue?.name }} </span>
                </template>
                <template #caret="{toggle}">
                    <font-awesome-icon icon="fa-solid fa-chevron-down" class="multiselect__select" style="display: none;"/>
                </template>
                <template #noResult>
                    <span class="custom-no-result">{{t('field.no_data')}}</span>
                </template>
                <template #noOptions>
                    <span class="multiselect-no-options">
                       {{t('field.search')}}
                    </span>
                </template>
            </VueMultiselect>
        </div>
        <div class="cell-filter not-client-id" v-if="type == 'multiselect' && props.name != 'clientId'">
            <VueMultiselect
                v-model="multiselectValue"
                :placeholder="$t('workfiles.fast_filters.all')"
                label="name"
                track-by="name"
                :options="props.data"
                :multiple="true"
                :searchable="false"
                :selectLabel="'✓'"
                :deselectLabel="''"
                :selectedLabel="'✓'"
                :preserve-search="true"
                :closeOnSelect="false"
                @update:modelValue="filterChanged"
                ref="multiselect">
                <template #selection="{ values, search, isOpen }">
                    <span class="multiselect-selection-length-text" v-if="values.length" v-show="!isOpen">{{ values.length }} {{values.length==1 ? t('workfiles.status') : t('field.states')}} </span>
                </template>
                <template #caret="{ toggle, isOpen }">
                    <font-awesome-icon
                        icon="fa-solid fa-chevron-down"
                        class="multiselect__select"
                        @mousedown.prevent.stop="handleChevronClick(isOpen, toggle)"
                    />
                </template>
            </VueMultiselect>
        </div>        
        <div class="cell-filter" v-if="['date', 'dateNoTime'].includes(type)" style="max-width: 165px;">
            <VueDatePicker 
                class="custom-dp-filter"
                range
                :teleport="true"
                v-model="date" 
                :six-weeks="true"
                :enable-time-picker="false" 
                :preset-dates="presetDates"
                :disabled-times="() => true"
                :format="dateformat"
                :year-range="[2000, 2050]"
                :hide-navigation="['month', 'year']"
                input-class-name="yauty-date-picker"
                :placeholder="placeholderDP" 
                week-start="1"
                prevent-min-max-navigation
                auto-apply
                utc
                locale="es-ES"
                format="dd/MM - dd/MM"
                position="left"
                @closed="handleDateChangeClosed"
                @open="handleFocusDP"
                @blur="handleCloseDP"
                @cleared="handleDateClear"
                @updateMonthYear="updateMonthYear"
                @internal-model-change="handleInternal"
                >
                <template #preset-date-range-button="{ label, value, presetDate }">
                    <span 
                        role="button"
                        :tabindex="0"
                        @click="presetDate(value)"
                        @keyup.enter.prevent="presetDate(value)"
                        @keyup.space.prevent="presetDate(value)">
                    {{ label }}
                    </span>
                </template>
                <template #month-year="{
                                month,
                                year,
                                months,
                                years,
                                updateMonthYear,
                                handleMonthYearChange
                            }">
                    <div class="calendar-custom-header">
                        <div class="icons" styles="with:32px;">
                            <font-awesome-icon icon="fa-solid fa-chevron-left" @click="minusMonth($event, updateMonthYear, month, year)" class="custom-icon"/>
                        </div>
                        <div class="custom-month-year-component">
                            <select 
                                class="select-input"
                                :value="month" 
                                @change="updateMonth($event, updateMonthYear, year)">
                                <option v-for="m in months" :key="m.value" :value="m.value" :class="{'selected':m.value == month}">{{ m.text }}</option>
                            </select>
                            <select 
                                class="select-input"
                                :value="year"
                                @change="updateYear($event, updateMonthYear, month)">
                                <option v-for="y in years" :key="y.value" :value="y.value" :class="{'selected':y.value == year}">{{ y.text }}</option>
                            </select>
                        </div>
                        <div class="icons" styles="with:32px;">
                            <font-awesome-icon icon="fa-solid fa-chevron-right" @click="addMonth($event, updateMonthYear, month, year)" class="custom-icon"/>
                        </div>
                    </div>
                </template>                
            </VueDatePicker>
        </div>
    </div>
</template>

<style lang="scss">
@import 'src/styles/colors.scss';
.custom-filter{
    width: 100%;
    .yauty-date-picker{
        font-size: 13px;
    }
    .cell-filter input{
        //border: 1px solid v-bind(inputBorderColor);
        border-radius: 30px;
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
        color: v-bind(textInputColor);
        font-size: 13px;
        padding-top: 0.13rem;
        padding-bottom: 0.13rem;
        background-color: rgba(0, 0, 0, 0) !important;
        z-index: 1;
    }
    .cell-filter input::placeholder{
        color: #0000008a !important;;
        font-size: 14px;
       font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
    }
    .cell-filter input.yauty-date-picker{
        height: 29.75px !important;
        padding-top: 0.2rem;
    }
    .cell-filter select{
        border: 1px solid #CBD5E1;
        border-radius: 30px;
        height: 37.6px;
        option{
            font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
            font-size: 16px;
        }
        option:checked {
            color: white;
            background-color: #707070;
        }    
    }
    .dp__input {
        color: v-bind(dateBorderColor) !important;
        font-size: 11px !important;
        &::placeholder {
            opacity: 1;
            color: #0000008a !important;
        }
    }
    .dp--menu-wrapper{
        z-index: 100 !important;
    }
    // .dp__pointer:focus-within{
    //     border: 1px solid v-bind(userColor) !important;
    // }
    .dp__input_icon {
        transform:translateY(-73%);
    }
    .dp__menu {
        --dp-border-radius: 20px;
    }
    .dp__menu_inner {
        padding:20px;
    }
    .dp__btn,
    .dp--time-overlay-btn,
    .dp--time-invalid,
    .dp--qr-btn {
        font-size: 14px;
        padding-left: 15px;
        margin-right: 10px;
       font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
    }
    .dp__calendar_item {
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
    }
    .dp__calendar_header_item {
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
    }
    .dp--preset-dates {
        padding:10px;
        border-inline-end:0px solid var(--dp-border-color);
    }
    .dp__arrow_top {
        left: v-bind(dpArrowTopPosition);
    }
    .dp__clear_icon {
        z-index: 2;
    }
    .dp__theme_light{
        --dp-input-padding: 0.5rem 0rem 0.5rem 1rem;
        --dp-menu-border-color: #fff;
        
        .dp__today {
            border: 1px solid v-bind(userColor) !important;
        }
        .dp__range_start,
        .dp__range_end{
            background-color: v-bind(userColor) !important;
        }
        .dp__range_between{
            background-color: #EFF3F3 !important;
        
        }
        .dp__menu_content_wrapper{
            border-radius: 20px;
            -webkit-box-shadow: 0 5px 10px 0 hsla(0, 0%, 0%, .05);
            box-shadow: 0 5px 10px #0000000d;
        }
        
        button.dp__btn:nth-child(1) {
            margin-top: 15px;
        }
        button:hover{
            background-color: v-bind(userColor) !important;
            color: white;
            border-radius: 30px;
        }
        button.dp--arrow-btn-nav span:hover{
            background-color: v-bind(userColor) !important;
            color: white;
        }
        button.dp--arrow-btn-nav{
            background-color: white !important;
        }
        input{
            border: 1px solid v-bind(dateBorderColor);
            border-radius: 30px;
        }
        svg{
            fill: v-bind(dateBorderColor);
        }
    }
    .calendar-custom-header{
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 10px;
        gap: 1.5rem;
        
        .custom-month-year-component{
            display: flex;
            justify-content: space-between;
            align-items: center;
            gap:5px;
            select{
                height: 37.6px;
                width: 75px;
                line-height: 1.25 !important;
                border-radius: 0.24rem;
                border: 0px solid v-bind(multiSelectColor);
                background-color: white !important;
                padding-left: 0.5rem !important;
                padding-right: 0 !important;
                padding-top: 0.5rem !important;
                padding-bottom: 0.5rem !important;
                position: relative;
                flex: 1 1 auto;
                min-width: 0;
                color: #707070;
                font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
            }
            select:focus {
                outline: none;
            }
        }
        .icons{
            display: flex;
            justify-content: space-between;
            align-items: center;
            .custom-icon{
                padding: 5px;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                color: #CBD5E1;
                font-size: 20px;
                cursor: pointer;
            }
            .custom-icon:hover{
                background-color: v-bind(userColor);
                color: white;
            }
        }
    }
    .multiselect-selection-length-text{
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
        color: v-bind(userColor);
        font-size: 13px;
    }
    /* Chrome, Firefox, Opera, Safari 10.1+ */
    input::placeholder {
        color: #0000008a !important;;
        font-size: 13px;
    }

    /* Internet Explorer 10-11 */
    input:-ms-input-placeholder {
        color: #0000008a !important;
        font-size: 13px;
    }

    /* Microsoft Edge */
    input::-ms-input-placeholder {
        color: #0000008a !important;
        font-size: 13px;
    }
    .multiselect {
        border: 1px solid v-bind(multiSelectColor) !important;
        font-family: system-ui, -apple-system, BlinkMacSystemFont,
               'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell,
               'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif !important;
        background-color: white;
        height: 28.2px !important;
        border-radius: 30px !important;
        .multiselect__placeholder {
            color: #0000008a !important;
            font-size: 13px;
            padding-top: 0px;
            margin-bottom: 0px;
        }
        .multiselect__tags {
            padding: 0.3rem 1rem 0.3rem 1rem;
            line-height: 1.3rem !important;
            position: absolute;
            border: 0;
            // top: 1px !important;
            min-height: 27px !important;
            height: 25px !important;
            background-color: rgba(0, 0, 0, 0);
            font-size: 13px !important;
        }
        .multiselect-selection-length-text{
            font-size: 13px;
        }
        .multiselect__select::before {
            border-color: v-bind(multiSelectColor) transparent transparent transparent;
        }
        .multiselect__content-wrapper {
            border-radius: 10px;
            position: absolute;
            width: 102%;
            overflow: visible;
            border-top: none;
            z-index: 1000;
            -webkit-overflow-scrolling: touch;
            position: absolute;
            border-top: none;
            top: 100% !important;
            left: 0 !important;
            right: auto !important;
            margin-top: 2px !important;
            font-size: 14px;
        }
        .multiselect__single {
            display: none;
        }
    }
    svg {
        fill: v-bind(userColor);
    }
}
.custom-table .columnheader_inner .upperHeader {
    padding-top: 0rem !important;
}
.multiselect__content-wrapper {
    overflow: scroll !important;
    box-shadow: 0 5px 10px #0000000d;
}

.not-client-id .multiselect__content-wrapper {
    min-height: 100px !important;
    height: v-bind(totalHeight) !important;
    
}

.little-height .multiselect__content-wrapper {
    min-height: 100px !important;
    height: v-bind(totalHeight) !important;
    
}
.multiselect__select {
    line-height: 10px;
    position: absolute;
    width: 15px;
    height: 15px;
    top: -9.5px;
    right: 1px;
    padding: 4px 12px;
    margin: 0;
    text-decoration: none;
    text-align: center;
    cursor: pointer;
    transition: transform 0.2s ease;
    color: v-bind(multiSelectColor);
}
.multiselect {
    box-sizing: content-box;
    position: relative;
    width: 100%;
    text-align: left;
    color: #35495e;
    border: 0 !important;
    border-radius: 0 !important; 
    min-height: unset !important;
    max-height: 37.6px !important;
    height: 37.6px !important;
    transition: border-color 0.3s ease;
}
.multiselect:focus-within{
    border: 1px solid v-bind(userColor) !important;
}
.custom-dp-filter:focus-within {
    border: 1px solid v-bind(userColor) !important;
    border-radius: 30px;
    
}
.multiselect__tags {
    min-height: 40px;
    padding: 8px 40px 0 8px;
    border-radius: 5px;
    border: 1px solid #e8e8e8;
    background: #fff;
    font-size: 14px;
}
.multiselect__content-wrapper {
    background: #fff;
    max-height: 100px !important;
    border: 0;
    border-top: none;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    z-index: 50;
    -webkit-overflow-scrolling: touch;
    top: 100% !important;
    left: 0 !important;
    right: auto !important;
    margin-top: 2px !important;
}
.multiselect__content {
    list-style: none;
    padding: 0;
    margin: 0;
    min-width: 100%;
    vertical-align: top;
    border-radius: 10px;
    border-top: none;
    box-shadow: 0 5px 10px #0000000d;
    min-width: 100%;
    background-color: white;
}
.multiselect__option--highlight::after {
    background: v-bind(userColor);
}
.multiselect__option--highlight {
    background: v-bind(userColor);
}
.multiselect__option--selected.multiselect__option--highlight::after {
    background-image: url('/src/assets/svg/xmark-solid.svg');
    background-repeat: no-repeat;
    height: 20px;
    top: 12px;
    padding-right: 7px;
}
#null-0 {
    span.multiselect__option {
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
    }
    span.multiselect__option::after {
        border-top-right-radius: 10px;
    }
}
#null-7 {
    span.multiselect__option {
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
    }
    span.multiselect__option::after {
        border-bottom-right-radius: 10px;
    }
}

ul.multiselect__content> li:nth-last-child(3)> span.multiselect__option--highlight {
    border-bottom-left-radius: 10px !important;
    border-bottom-right-radius: 10px !important;
}
ul.multiselect__content> li:nth-last-child(3)> span.multiselect__option--highlight::after {
    border-bottom-right-radius: 10px !important;
}


.clearInputText svg{
    padding: 6px;
}
.search-svg{
    position: absolute;
    left: 10px;
    top: 5px;
    cursor: text;
    z-index: 0;
    svg{
        color:#cbd5e1;
    }
}
.fa-ellipsis-vertical > path {
    fill: #c8cfd9;
}
.m-btn.--is-button.--transparent:not(:disabled):hover > span > .fa-ellipsis-vertical > path {
    fill: #000000;
    transition: 0.3s linear;
}
.btn {
    right: 18px;
    @media (max-width:576px) {
        display: none !important;
    }
}
input:-webkit-autofill,
input:-webkit-autofill:hover, 
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
    -webkit-text-fill-color: v-bind(userColor);
    -webkit-box-shadow: 0 0 0px 1000px white inset;
    transition: background-color 5000s ease-in-out 0s;
};
.multiselect__tags input:focus {
        outline: none !important;
        box-shadow: none !important;
        border: none !important;
    }

.multiselect__tags input {
    height: auto !important; /* Allow the input to resize dynamically */
    overflow: hidden; /* Hide overflow content */
    text-overflow: ellipsis !important; /* Add ellipsis for long text */
    white-space: nowrap; /* Prevent text wrapping */
}
</style>
